import Vue from 'vue'
import i18next from 'i18next'
import moment from 'moment'
import VueI18Next from '@panter/vue-i18next'

import locales from '../locales'

Vue.use(VueI18Next)

const getOptions = function () {
  const ignoreList = [
    'Admin-Dashboard',
    'VBus® Data Viewer',
    'VBus<sup>®</sup> Data Viewer',
    'KM2-Password-SEED',
    'Support-Report',
    'Statistic',
    'Ownership Data',
    'Support-Dashboard',
    'Settings Documentation Generator',
    'Changelog',
    'Ownership-Data',
    'Distribution-Dashboard',
    'FAQ',
    'Online-Devices',
    'Check-E-Mails',
    'Device-Discovery-Tool',
    'Fachpartner'
  ]
  let options = {
    debug: false,
    lng: 'de',
    fallbackLng: 'en',
    interpolation: {
      prefix: '{',
      suffix: '}'
    },
    returnEmptyString: false,
    resources: locales
  }
  if (process.env.NODE_ENV === 'development') {
    options.parseMissingKeyHandler = (key) => {
      if (ignoreList.indexOf(key) === -1) {
        console.log('%c[i18n] No translation found for: %s', 'color: #FF5722;', key)
      }
      return key
    }
  }
  return options
}

i18next.on('initialized', () => {
  // console.log('%c[i18n] initialized √', 'color: green;')
})

i18next.on('missingKey', (lngs, namespace, key, res) => {
  console.log('%c[i18n] Missing (%s): %s', 'color: #FF5722;', lngs, key)
})

i18next.on('languageChanged', (lng) => {
  if (typeof lng === 'string') {
    moment.locale(lng)
  }
  // console.log('%c[i18n] Language changed to: %s', 'color: blue;', lng)
})

const options = getOptions()

i18next.init(options)

const i18n = new VueI18Next(i18next)

Vue.directive('t', {
  bind: function (el, binding, vnode) {
    el.innerHTML = i18next.t(binding.value)
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/plugins/i18n.js